import useProjectRoles from 'screens/Admin/ProjectRoles/hooks/useProjectRoles'
import { IProjectRole } from 'screens/Admin/ProjectRoles/projectRoles.types'
import Dropdown from 'shared/Inputs/Dropdown'

interface IProps {
  value: string[] | undefined
  name: string
  onChange: (val: string[], name: string) => void
}

const FaqRolesSelect = (props: IProps) => {
  const { loadMore, projectRolesState, loading, projectRolesMap } = useProjectRoles()

  const handleSelect = (val: IProjectRole[]) => {
    props.onChange(
      val.map((v) => v.id),
      props.name
    )
  }

  const selected = props.value?.map((v) => projectRolesMap[v]) ?? []

  return (
    <Dropdown
      options={projectRolesState.items}
      selectedOption={selected}
      title='Роли'
      onSelect={handleSelect}
      getOptionKey={(o) => o?.id}
      getOptionLabel={(o) => o?.title}
      multiple
      loading={loading}
      infinityLoadProps={{
        loadMore,
        isMore: projectRolesState.nextPage !== null,
      }}
    />
  )
}

export default FaqRolesSelect
